import { ProjectDetails, ProjectDetailsDto } from "@features/project/components/pages/project-details/types/project-details.type";


// eslint-disable-next-line @tseslint/typedef
export const PROJECT_STATUSES = {
  active: "active",
  completed: "completed"
} as const;
export type ProjectStatus = typeof PROJECT_STATUSES[keyof typeof PROJECT_STATUSES];
export interface ProjectHeader extends Pick<ProjectDetails, "number" | "name" | "plannedStart" | "plannedEnd"> {
  status: ProjectStatus;
}
export interface ProjectHeaderDto extends Pick<ProjectDetailsDto, "number" | "name" | "plannedStart" | "plannedEnd"> {
  completed: boolean;
}
export function parseToProjectHeader (value: ProjectHeaderDto): ProjectHeader {
  return {
    number: value.number,
    name: value.name,
    plannedStart: new Date(value.plannedStart),
    plannedEnd: new Date(value.plannedEnd),
    status: value.completed ? PROJECT_STATUSES.completed : PROJECT_STATUSES.active
  };
}
